"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationSchemas = (function () {
    function ValidationSchemas() {
    }
    ValidationSchemas.MEDIUMGROUPS_SCHEMA = {
        "type": "object",
        "properties": {
            "mediumGroup": {
                "type": "array",
                "items": {
                    "$ref": "#/definitions/placement"
                }
            },
            "required": ["mediumGroup"],
            "additionalProperties": false
        },
        "definitions": {
            "placement": {
                "type": "object",
                "properties": {
                    "medium": {
                        "type": "object",
                        "properties": {
                            "type": {
                                "type": "string",
                                "minLength": 1
                            },
                            "key": {
                                "type": "string",
                                "minLength": 1
                            },
                            "period": {
                                "type": "string",
                                "minLength": 1
                            },
                            "longTitle": {
                                "type": "string",
                                "minLength": 1
                            }
                        },
                        "required": [
                            "type",
                            "key"
                        ],
                        "additionalProperties": false
                    },
                    "conditions": {
                        "type": "object",
                        "properties": {
                            "gross": {
                                "type": "boolean"
                            },
                            "agencyCommission": {
                                "type": "number", "minimum": 0
                            },
                            "cashDiscount": {
                                "type": "number", "minimum": 0
                            },
                            "vat": {
                                "type": "number", "minimum": 0
                            },
                            "rateCard": {
                                "type": "object",
                                "properties": {
                                    "date": {
                                        "type": "string",
                                        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z"
                                    },
                                    "dateRule": {
                                        "type": "string",
                                        "pattern": "(ByExactDate|MostRecent|MostRecentOfYear|MostRecentOfYearAndMonth)"
                                    },
                                    "daysOfWeek": {
                                        "type": "array"
                                    }
                                },
                                "required": [
                                    "date",
                                    "dateRule",
                                    "daysOfWeek"
                                ],
                                "additionalProperties": false
                            },
                            "online": {
                                "type": "object",
                                "properties": {
                                    "adFormat": {
                                        "type": "string"
                                    },
                                    "pricing": {
                                        "type": "string",
                                        "pattern": "(TryFixPrice|PlanDetailsMoney|FixPrice)"
                                    },
                                    "fixedPriceWithShare": {
                                        "type": "boolean"
                                    },
                                    "proprietaryName": { "type": "string" },
                                    "specialCpm": { "type": "number" },
                                    "specialFixedPrice": { "type": "number" },
                                    "specialFixedPriceIgnoresFrequency": { "type": "boolean" }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false
                    },
                    "frequency": {
                        "type": "integer", "minimum": 0
                    },
                    "pi": {
                        "type": "number", "minimum": 0
                    },
                    "share": {
                        "type": "number", "minimum": 0, "maximum": 100
                    },
                    "frequencyCapping": {
                        "type": "object",
                        "properties": {
                            "impressions": {
                                "type": "integer",
                                "minimum": 0
                            },
                            "forTotal": {
                                "type": "boolean"
                            }
                        },
                        "required": ["impressions"],
                        "additionalProperties": false
                    },
                    "targeting": {
                        "type": "object",
                        "properties": {
                            "keys": {
                                "type": "array",
                                "items": { "type": "string" },
                                "minItems": 0
                            },
                            "wastage": { "type": "number", "minimum": 0 }
                        },
                        "required": ["keys"],
                        "additionalProperties": false
                    },
                    "tag": {
                        "type": "string",
                        "minLength": 1
                    },
                    "group": {
                        "type": "string"
                    },
                    "userAnnotation": {
                        "type": "string"
                    },
                    "specialDiscounts": {
                        "type": "object",
                        "properties": {
                            "amount1": { "type": "number" },
                            "amount2": { "type": "number" },
                            "amount3": { "type": "number" },
                            "amount4": { "type": "number" },
                            "amount5": { "type": "number" },
                            "type": { "type": "string", "minLength": 1 }
                        },
                        "additionalProperties": false
                    },
                    "additionalData": {
                        "type": "object",
                        "properties": {
                            "specialDiscount": {
                                "type": "string",
                                "minLength": 1
                            },
                            "frequencyCappingFormatted": {
                                "type": "string",
                                "minLength": 0
                            },
                            "adformatInformation": {
                                "type": "string",
                                "minLength": 1
                            },
                            "proprietaryName": {
                                "type": "string",
                                "minLength": 1
                            },
                            "calculationTypeName": {
                                "type": "string",
                                "minLength": 1
                            },
                            "ignoreFrequencyString": {
                                "type": "string",
                                "minLength": 1
                            },
                            "frequencyCappingForTotal": {
                                "type": "boolean"
                            },
                            "wastageActive": {
                                "type": "boolean"
                            },
                            "targetingSummaryLong": {
                                "type": "string"
                            },
                            "specialPriceData": {
                                "type": "object",
                                "properties": {
                                    "specialCpm": {
                                        "type": "boolean"
                                    },
                                    "specialCpmAmount": {
                                        "type": "number",
                                        "minimum": 0
                                    },
                                    "specialFixedPrice": {
                                        "type": "boolean"
                                    },
                                    "specialFixedPriceAmount": {
                                        "type": "number",
                                        "minimum": 0
                                    },
                                    "specialFixedPriceIgnoresFrequency": {
                                        "type": "boolean"
                                    },
                                    "proprietaryName": {
                                        "type": "string"
                                    },
                                    "description": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false
                    }
                },
                "oneOf": [
                    {
                        "required": [
                            "pi"
                        ]
                    },
                    {
                        "required": [
                            "share"
                        ]
                    },
                ],
                "required": [
                    "medium",
                    "conditions",
                    "frequency",
                ],
                "additionalProperties": false
            }
        }
    };
    ValidationSchemas.MEDIUMGROUPS_SCHEMA_ARRAY = {
        "type": "array",
        "items": {
            "type": "object",
            "properties": {
                "mediumGroup": {
                    "type": "array",
                    "items": {
                        "$ref": "#/definitions/placement"
                    }
                },
                "required": ["mediumGroup"],
                "additionalProperties": false
            }
        },
        "definitions": {
            "placement": {
                "type": "object",
                "properties": {
                    "medium": {
                        "type": "object",
                        "properties": {
                            "type": {
                                "type": "string",
                                "minLength": 1
                            },
                            "key": {
                                "type": "string",
                                "minLength": 1
                            },
                            "period": {
                                "type": "string",
                                "minLength": 1
                            },
                            "longTitle": {
                                "type": "string",
                                "minLength": 1
                            }
                        },
                        "required": [
                            "type",
                            "key"
                        ],
                        "additionalProperties": false
                    },
                    "conditions": {
                        "type": "object",
                        "properties": {
                            "gross": {
                                "type": "boolean"
                            },
                            "agencyCommission": {
                                "type": "number", "minimum": 0
                            },
                            "cashDiscount": {
                                "type": "number", "minimum": 0
                            },
                            "vat": {
                                "type": "number", "minimum": 0
                            },
                            "rateCard": {
                                "type": "object",
                                "properties": {
                                    "date": {
                                        "type": "string",
                                        "pattern": "[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z"
                                    },
                                    "dateRule": {
                                        "type": "string",
                                        "pattern": "(ByExactDate|MostRecent|MostRecentOfYear|MostRecentOfYearAndMonth)"
                                    },
                                    "daysOfWeek": {
                                        "type": "array"
                                    }
                                },
                                "required": [
                                    "date",
                                    "dateRule",
                                    "daysOfWeek"
                                ],
                                "additionalProperties": false
                            },
                            "online": {
                                "type": "object",
                                "properties": {
                                    "adFormat": {
                                        "type": "string"
                                    },
                                    "pricing": {
                                        "type": "string",
                                        "pattern": "(TryFixPrice|PlanDetailsMoney|FixPrice)"
                                    },
                                    "fixedPriceWithShare": {
                                        "type": "boolean"
                                    },
                                    "proprietaryName": { "type": "string" },
                                    "specialCpm": { "type": "number" },
                                    "specialFixedPrice": { "type": "number" },
                                    "specialFixedPriceIgnoresFrequency": { "type": "boolean" }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false
                    },
                    "frequency": {
                        "type": "integer", "minimum": 0
                    },
                    "pi": {
                        "type": "number", "minimum": 0
                    },
                    "share": {
                        "type": "number", "minimum": 0, "maximum": 100
                    },
                    "frequencyCapping": {
                        "type": "object",
                        "properties": {
                            "impressions": {
                                "type": "integer",
                                "minimum": 0
                            },
                            "forTotal": {
                                "type": "boolean"
                            }
                        },
                        "required": ["impressions"],
                        "additionalProperties": false
                    },
                    "targeting": {
                        "type": "object",
                        "properties": {
                            "keys": {
                                "type": "array",
                                "items": { "type": "string" },
                                "minItems": 0
                            },
                            "wastage": { "type": "number", "minimum": 0 },
                            "shortCaption": { "type": "string", "minLength": 1 }
                        },
                        "required": ["keys"],
                        "additionalProperties": false
                    },
                    "targetingSummaryLong": {
                        "type": "string",
                        "minLength": 1
                    },
                    "tag": {
                        "type": "string",
                        "minLength": 1
                    },
                    "group": {
                        "type": "string"
                    },
                    "userAnnotation": {
                        "type": "string"
                    },
                    "specialDiscounts": {
                        "type": "object",
                        "properties": {
                            "amount1": { "type": "number" },
                            "amount2": { "type": "number" },
                            "amount3": { "type": "number" },
                            "amount4": { "type": "number" },
                            "amount5": { "type": "number" },
                            "type": { "type": "string", "minLength": 1 }
                        },
                        "additionalProperties": false
                    },
                    "additionalData": {
                        "type": "object",
                        "properties": {
                            "specialDiscount": {
                                "type": "string",
                                "minLength": 1
                            },
                            "frequencyCappingFormatted": {
                                "type": "string",
                                "minLength": 0
                            },
                            "adformatInformation": {
                                "type": "string",
                                "minLength": 1
                            },
                            "proprietaryName": {
                                "type": "string",
                                "minLength": 1
                            },
                            "calculationTypeName": {
                                "type": "string",
                                "minLength": 1
                            },
                            "ignoreFrequencyString": {
                                "type": "string",
                                "minLength": 1
                            },
                            "frequencyCappingForTotal": {
                                "type": "boolean"
                            },
                            "wastageActive": {
                                "type": "boolean"
                            },
                            "targetingSummaryLong": {
                                "type": "string"
                            },
                            "specialPriceData": {
                                "type": "object",
                                "properties": {
                                    "specialCpm": {
                                        "type": "boolean"
                                    },
                                    "specialCpmAmount": {
                                        "type": "number",
                                        "minimum": 0
                                    },
                                    "specialFixedPrice": {
                                        "type": "boolean"
                                    },
                                    "specialFixedPriceAmount": {
                                        "type": "number",
                                        "minimum": 0
                                    },
                                    "specialFixedPriceIgnoresFrequency": {
                                        "type": "boolean"
                                    },
                                    "proprietaryName": {
                                        "type": "string"
                                    },
                                    "description": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false
                    }
                },
                "oneOf": [
                    {
                        "required": [
                            "pi"
                        ]
                    },
                    {
                        "required": [
                            "share"
                        ]
                    },
                ],
                "required": [
                    "medium",
                    "conditions",
                    "frequency",
                ],
                "additionalProperties": false
            }
        }
    };
    ValidationSchemas.CONDITIONS_SCHEMA = {
        "type": "object",
        "properties": {
            "agencyCommission": {
                "type": "number",
                "minimum": 0
            },
            "cashDiscount": {
                "type": "number",
                "minimum": 0
            },
            "vat": {
                "type": "number",
                "minimum": 0
            },
            "gross": {
                "type": "boolean"
            },
            "online": {
                "type": "object",
                "properties": {
                    "adFormat": {
                        "type": "string"
                    },
                    "pricing": {
                        "type": "string"
                    },
                    "altAdFormat": {
                        "type": "string"
                    },
                    "fixedPriceWithShare": {
                        "type": "boolean"
                    },
                    "specialFixedPrice": {
                        "type": "number",
                        "minimum": 0
                    },
                    "specialFixedPriceIgnoresFrequency": {
                        "type": "boolean"
                    },
                    "specialCpm": {
                        "type": "number",
                        "minimum": 0
                    }
                },
                "required": ["adFormat", "pricing"],
                "additionalProperties": false
            },
            "rateCard": {
                "type": "object",
                "properties": {
                    "date": "string",
                    "dateRule": "string",
                    "daysOfWeek": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                "required": ["date", "dateRule", "daysOfWeek"],
                "additionalProperties": false
            }
        },
        "additionalProperties": false
    };
    ValidationSchemas.AUDIENCE_SCHEMA = {
        "type": "object",
        "properties": {
            "type": {
                "type": "string",
                "minLength": 1
            },
            "key": {
                "type": "string",
                "minLength": 1
            },
            "required": ["type", "key"],
            "additionalProperties": false
        }
    };
    ValidationSchemas.MEDIUM_ARRAY_SCHEMA = {
        "type": "array",
        "items": {
            "type": "object",
            "properties": {
                "type": { "type": "string", "minLength": 1 },
                "key": { "type": "string", "minLength": 1 },
                "period": { "type": "string", "minLength": 1 },
                "longTitle": { "type": "string", "minLength": 1 }
            },
            "required": ["type", "key", "longTitle"],
            "additionalProperties": false
        }
    };
    ValidationSchemas.CALCBASE_ARRAY_SCHEMA = {
        "type": "array",
        "items": {
            "type": "object",
            "properties": {
                "mediumGroup": {
                    "type": "array",
                    "items": {
                        "frequencyCapping": {
                            "type": "object",
                            "properties": {
                                "value": { "type": "number", "minimum": 0 },
                                "adFormat": { "type": "string", "minlength": 1 },
                                "period": { "type": "string", "minlength": 1 },
                                "min": { "type": "number", "minimum": 0 },
                                "max": { "type": "number", "minimum": 0 }
                            },
                            "required": ["value", "adFormat", "min", "max"],
                            "additionalProperties": false
                        },
                        "targeting": {
                            "type": "object",
                            "properties": {
                                "targetingType": { "type": "number", "minlength": 1 },
                                "targetingFeature": { "type": "string", "minlength": 1 },
                                "code": { "type": "string", "minlength": 1 }
                            },
                            "required": ["targetingType", "targetingFeature", "code"],
                            "additionalProperties": false
                        },
                        "cpm": {
                            "type": "object",
                            "properties": {
                                "amount": { "type": "number", "minValue": 0 },
                                "currency": { "type": "string", "minLength": 1 },
                                "onRequest": { "type": "boolean" }
                            },
                            "required": ["amount", "currency"],
                            "additionalProperties": false
                        }
                    }
                }
            }
        }
    };
    return ValidationSchemas;
}());
exports.ValidationSchemas = ValidationSchemas;
//# sourceMappingURL=validationSchemas.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/validationSchemas.js
// module id = 84
// module chunks = 0